var map = {
	"./NIH_NIAID.png": 154,
	"./bmfoundation.png": 233,
	"./ehime.png": 157,
	"./johns_hopkins.png": 158,
	"./kangwon.png": 159,
	"./knih.png": 161,
	"./mahidol.png": 163,
	"./oklahoma.png": 164,
	"./pennState.png": 234,
	"./pros.png": 166,
	"./trf.png": 167,
	"./wehi.png": 168,
	"./wellcome.png": 169
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 396;



//////////////////
// WEBPACK FOOTER
// ./src/images/collaborators nonrecursive \.(pn?g)$
// module id = 396
// module chunks = 74537795826934 162898551421021